import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import {
  fetchSetOfferLabel,
  ISetOfferLabelResponse200,
  ISetOfferLabelResponse400,
} from '../../../repositories/e2e-deal-entrypoints/v1/set-offer-label';
import { ISetE2eLabelDependencies } from './types';

export const setE2eLabel = async (dependencies: ISetE2eLabelDependencies) => {
  const { httpApi, logger, parameters } = dependencies;

  try {
    const res = await fetchSetOfferLabel<ISetOfferLabelResponse200, ISetOfferLabelResponse400>({
      httpApi,
      parameters,
    });

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        message: 'Failed to set status code for user',
        statusCode: res.statusCode,
        domain: 'setE2eLabel',
      });
    }

    return res.response;
  } catch (error) {
    logger.error(error, {
      description: 'e2e-deal-entrypoints /v1/set-offer-label/ reject error',
      requestParameters: { ...parameters },
    });

    throw error;
  }
};
